export default __webpack_public_path__ + "static/media/red_team_win.f176dc7f.webp";